import React, { useEffect, useState } from 'react';
import { Box, VStack, Heading, Text, Button, Center, Image, Spinner, Input, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
import { useUser } from '../../Context/User';
import StyledButtonBase from '../../GlobalComponents/StyledButtonBase';
import loginPic from './assets/Login_Background.png';

const LoginView = () => {
  const { isLoggedIn, userInfo, login, isLoading } = useUser();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const boxColor = useColorModeValue('white', 'gray.700');
  const textColor = "rcBrand.lime";

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/home');
    }
  }, [isLoggedIn, navigate]);

  const handleLogin = () => {
    // Call your login logic here, passing username and password
    login({ username, password });
  };

  // If isLoading is true, show the spinner
  if (isLoading) {
    return (
      <Center h="100vh" w="100%">
        <Spinner />
      </Center>
    );
  }

  return (
    <Box position="relative" h="100vh" w="100%">
      {/* Wrapper box to apply the background color, opacity, and backdrop filter */}
      <Box 
        position="absolute" 
        top="0" 
        left="0" 
        h="100%" 
        w="100%" 
        background="#023F2E" // Dark green background color
        opacity="0.75" // 75% opacity
        backdropFilter="blur(100px)" // Apply a 100px blur filter
        zIndex="1"
      />
      {/* Image as the background */}
      <Image
        src={loginPic}
        position="absolute"
        top="0"
        h="100vh" // Full screen height
        w="100%" // Full screen width
        objectFit="cover" // Cover the entire area, preserving aspect ratio
        zIndex="0" // Behind the overlay and the content
      />
      <Center h="100%" w="100%" zIndex="2" position="relative">
        <Box
          w="520px"
          h="442px"
          p={8}
          backgroundColor="rgba(0, 0, 0, 0.6)" 
          borderRadius="md"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <VStack spacing={9} textAlign="center" w="75%">
            <Heading color={textColor} fontSize={24} >Login</Heading>
            {/* Username Input */}
                 {/* Username Input */}
                 <Input
              placeholder="Username"
              background="white" // White background
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              variant="filled"
              color="gray.800" // Dark text color
              _placeholder={{ color: 'gray.400' }} // Placeholder color
              p={5} // Padding for better readability
              _hover={{ background: 'white' }} // Disable hover transparency
              _focus={{ background: 'white' }} // Disable focus transparency
            />

            {/* Password Input */}
            <Input
              placeholder="Password"
              background="white" // White background
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="filled"
              type="password"
              color="gray.800" // Dark text color
              _placeholder={{ color: 'gray.400' }} // Placeholder color
              p={5} // Padding for better readability
              _hover={{ background: 'white' }} // Disable hover transparency
              _focus={{ background: 'white' }} // Disable focus transparency
            />
                        <Button
              color={textColor}
              variant="link"
              onClick={() => console.log('Forgot Password clicked')}
              fontSize={18}
              _hover={{
                shadow: "lg",
                transform: "translateY(-2px)",
              }}
            >
              Forgot Password
            </Button>

            {/* Login Button */}
            <StyledButtonBase onClick={handleLogin}>Login</StyledButtonBase>


          </VStack>
        </Box>
      </Center>
    </Box>
  );
};

export default LoginView;
